document.addEventListener('DOMContentLoaded', (event) => {
  // Your code here...

if (!customElements.get('product-form-mini')) {
  customElements.define('product-form-mini', class ProductFormMini extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('product-form-mini loaded');
      this.form = this.querySelector('form');
      this.mainImage = this.closest('.card').querySelector('.card__main-image');
      this.swatches = this.querySelectorAll('.variant__swatch-mini');
      this.formSelect = this.querySelector('.product-single__variants');
      if (this.swatches != null) {
        for (let i = 0; i < this.swatches.length; i++) {
          this.swatches[i].addEventListener('change', this.onSwatchChange.bind(this, this.swatches[i]));
        }
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    }

    onSwatchChange(swatch, evt) {
      let variantId = swatch.value;
      // let variantImage = swatch.dataset.variantImage;
      // let newVariantImage = variantImage.substring(0, variantImage.lastIndexOf('.'))
      // let oldVariantImage = this.mainImage.src.substring(5, this.mainImage.src.lastIndexOf('_'));
      // let newSrcset = this.mainImage.srcset.replaceAll(oldVariantImage, newVariantImage);
      // /*console.log(oldVariantImage, '***', newVariantImage, '***', newSrcset);*/

      // this.mainImage.src = variantImage;
      // this.mainImage.srcset = "";

      this.formSelect.value = variantId;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      /*this.handleErrorMessage();*/
      /*this.cartNotification.setActiveElement(document.activeElement);*/

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      /*formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));*/
      /*formData.append('sections_url', window.location.pathname);*/
      config.body = formData;
      pintrk('track', 'addtocart', {
        product_id: formData.get("id")
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }


          //Get Cart Content
          fetch('/cart.js')
            .then((response) => response.json())
            .then((response) => {
              console.log('GET CART CONTENTS', response);
              let itemCount = document.getElementById('item--count');
              let items = response.item_count;
              let plural = 'items';
              let single = 'item';
              if (items <= 1) {
                itemCount.innerHTML = `${items}  <span>${single}</span>`;
              } else {
                itemCount.innerHTML = `${items}  <span>${plural}</span>`;
              }

            
              let cartItems = response.items;

              console.log('ITEMS', items);
              console.log('SUBTOTAL PRICE', response.items_subtotal_price);
           

              if (response.items_subtotal_price >= 5500) {
                let giftWithPurchaseModule = document.getElementById('gwp');
                console.log("Condition met, changing display to block");
                giftWithPurchaseModule.style.display == 'block!important';

              } else {

                giftWithPurchaseModule.style.display = 'none!important'

                cartItems.filter((item) => {

                  console.log('ITEMS product--form-mini', item.product_type);
                
                  if (item.product_type === 'Free Product') {
                    giftWithPurchaseModule.style.display = 'none'
                    return;
                  } 
                });
                reloadCart();
              }
            })


          /*this.cartNotification.renderContents(response);*/
          // handle upsell
          let upsellForm = document.querySelector('.product__upsell-form');
          let upsellCheckbox = document.querySelector('.product__upsell-checkbox');
          reloadCart();
          openCart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

  })
}});